function isInViewport(elem: HTMLElement) {
    const bounding = elem.getBoundingClientRect();

    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export default function scrollToInput(inputName: string): void {
    const headerEl = document.getElementById('cartheader');
    const gutter = 30;
    const scrollBehavior = 'smooth';
    let offset = 0;

    if (headerEl) {
        offset = headerEl.offsetHeight + gutter;
    }

    const inputEl = document.getElementsByName(inputName);

    if (inputEl && inputEl.length === 1 && !isInViewport(inputEl[0])) {
        window.scrollTo({
            top: inputEl[0].getBoundingClientRect().top + window.pageYOffset - offset,
            behavior: scrollBehavior,
        });
    }
}
